<template>
    <div class="page-loading" v-if="loading">
        <div class="loading-mask">
            <van-loading type="spinner" color="#8B0000" vertical>加载中...</van-loading>
        </div>
    </div>
    <div v-else>
        <slot></slot>
    </div>
</template>

<script setup>
// Props
defineProps({
    loading: {
        type: Boolean,
        default: true
    }
})
</script>

<style scoped>
.page-loading {
    position: relative;
    min-height: 100vh;
}

.loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style> 